import { AVATAR_CATALOG, PRODUCT_AVATARS, type AvatarId } from '@shared/game/types';
import { Avatar } from './Avatar';
import { Icon } from './Icon';

interface AvatarPickerProps {
  selected: AvatarId;
  onSelect: (avatar: AvatarId) => void;
  unlocked?: AvatarId[];
  compact?: boolean;
}

export function AvatarPicker({ selected, onSelect, unlocked = [], compact = false }: AvatarPickerProps) {
  return (
    <div className={`avatar-picker ${compact ? 'avatar-picker--compact' : ''}`} role="listbox" aria-label="Elige tu avatar">
      {AVATAR_CATALOG.map((avatar) => {
        const locked = Boolean(avatar.premium) && !unlocked.includes(avatar.id);
        return (
          <button
            type="button"
            key={avatar.id}
            className={`avatar-choice ${selected === avatar.id ? 'is-selected' : ''} ${locked ? 'is-locked' : ''}`}
            onClick={() => {
              if (!locked) onSelect(avatar.id);
            }}
            role="option"
            aria-selected={selected === avatar.id}
            aria-label={`${avatar.name}${locked ? ', bloqueado' : ''}`}
            title={locked ? `${avatar.name} · Pack Cosmético` : `${avatar.name} · ${avatar.tagline}`}
            disabled={locked}
          >
            <span className="avatar-choice__art">
              <Avatar avatar={avatar.id} size={compact ? 46 : 58} decorative />
              {locked && (
                <span className="avatar-choice__lock">
                  <Icon name="lock" size={13} />
                </span>
              )}
            </span>
            {!compact && <span className="avatar-choice__name">{avatar.name}</span>}
          </button>
        );
      })}
      {PRODUCT_AVATARS.length > 0 && unlocked.length === 0 && !compact && (
        <p className="avatar-picker__hint">
          <Icon name="lock" size={13} /> Dos avatares se desbloquean con el pack cosmético.
        </p>
      )}
    </div>
  );
}
